
<template>
  <div class="HistoriaClinicaCard">
    <v-card
      shaped
      outlined
    >
      <v-card-title>Mi Historia Clínica</v-card-title>
      <v-card-text>
        <p class="text-center mb-0">
          Consulta toda tu información médica, citas, tratamientos y más
        </p>
      </v-card-text>
      <v-card-actions>
        <v-btn
          :to="rutaHistoriaClinica"
          block
          color="primary"
          outlined
        >
          Ver mi historia clínica
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "HistoriaClinicaCard",
  computed: {
    rutaHistoriaClinica() {
      const pacienteId = this.$session.get('id');
      if (pacienteId) {
        return `/paciente/historiaclinica/citas`;
      }
      return '/login';
    },
  },
};
</script>

